<template>
  <div class="right-content">
    <div class="section site-overview">
      <div class="title-wrap">
        <el-image style="width: 100%; height: 100%" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/title-bg-0.png"></el-image>
      </div>
      <div class="content-wrap">
        <div class="echarts-container">
          <div class="site-overview-echarts"></div>
        </div>
        <div class="info-container">
          <div class="info-item" v-for="(item, i) in siteData.data" :key="i" :style="{ background: siteData.bgColors[i] }">
            <div class="label">{{ item.name }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section device-overview">
      <div class="title-wrap">
        <el-image style="width: 100%; height: 100%" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/title-bg-1.png"></el-image>
      </div>
      <div class="content-wrap">
        <div class="echarts-container">
          <div class="device-overview-echarts"></div>
        </div>
        <div class="info-container">
          <div class="info-item" v-for="(item, i) in equipmentData.data" :key="i" :style="{ background: equipmentData.bgColors[i] }">
            <div class="label">{{ item.name }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="section alarm-message">
      <div class="title-wrap">
        <el-image style="width: 100%; height: 100%" src="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/templateBigScreen4/title-bg-2.png"></el-image>
      </div>
      <div class="content-wrap">
        <div class="strategyBox" v-if="alarmMessageDataList && alarmMessageDataList.length > 0" >
          <div class="titleBox">
            <div class="trBox">
              <div class="thBox">告警设备</div>
              <div class="thBox">告警等级</div>
              <div class="thBox">发生时间</div>
              <div class="thBox">事件</div>
            </div>
          </div>
          <div class="contentBox">
            <div v-for="(item, i) in alarmMessageDataList" :key="i" class="trBox" :class="{ 'animate-up': animateUp }">
              <div class="tdBox">{{ item.equipmentName }}</div>
              <div :title="item.controlName" class="tdBox">
                {{ item.levelStr }}
              </div>
              <!-- <div :title="item.executeTime" class="tdBox , timedisplaystyle" >
                {{ item.time }}
              </div> -->
              <div class="tdBox" :title="item.time">
                {{ item.time }}
              </div>
              <div class="tdBox">{{ item.triggerRule }}</div>
            </div>
          </div>
         
        </div>
          <el-empty class="custom-empty" description="系统运行正常" v-else ></el-empty>
      </div>
       
    </div>
  </div>
</template>

<script setup>
import { ElImage } from "element-plus";
import * as echarts from "echarts";
import { onMounted, ref, defineProps, computed, watch } from "vue";

const props = defineProps({
  dataDetail: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

const siteData = ref({
  data: [
    { name: "正常站点", value: 0, key: "normalStationNum" },
    { name: "异常站点", value: 0, key: "abnormalStationNum" },
  ],
  colors: ["rgba(89, 209, 120,1)", "rgba(241, 65, 56,1)"],
  bgColors: ["rgba(89, 209, 120,.1)", "rgba(241, 65, 56,.1)"],
});
const equipmentData = ref({
  data: [
    { name: "水泵总数", value: 0, key: "waterPumpNum" },
    { name: "风机总数", value: 0, key: "waterFanNum" },
  ],
  colors: ["rgba(55, 199, 255,1)", "rgba(50, 118, 241,1)"],
  bgColors: ["rgba(55, 199, 255,.1)", "rgba(50, 118, 241,.1)"],
});

let alarmMessageDataList = ref([
  {
    deviceName: "设备1",
    controlName: "控制1",
    executeTime: "2023-01-01 ",
    message: "大师傅士大夫撒旦大师傅士大夫士大夫",
  },
  {
    deviceName: "设备2",
    controlName: "控制2",
    executeTime: "2023-01-01",
    message: "大师傅士大夫撒旦大师傅士大夫士大夫",
  },
  {
    deviceName: "设备3",
    controlName: "控制2",
    executeTime: "2023-01-01",
    message: "大师傅士大夫撒旦大师傅士大夫士大夫",
  },
  {
    deviceName: "设备4",
    controlName: "控制2",
    executeTime: "2023-01-01",
    message: "大师傅士大夫撒旦大师傅士大夫士大夫",
  },
  {
    deviceName: "设备5",
    controlName: "控制2",
    executeTime: "2023-01-01",
    message: "大师傅士大夫撒旦大师傅士大夫士大夫",
  },
  {
    deviceName: "设备6",
    controlName: "控制2",
    executeTime: "2023-01-01",
    message: "大师傅士大夫撒旦大师傅士大夫士大夫",
  },
  {
    deviceName: "设备7",
    controlName: "控制2",
    executeTime: "2023-01-01",
    message: "大师傅士大夫撒旦大师傅士大夫士大夫",
  },
]);

let pieChartLoad = function (className, data) {
  var chartDom = document.querySelector(className);
  var myChart = echarts.init(chartDom);
  let option = {
    color: data.colors || ["#617899", "#5397ff", "#0fdda8"],
    legend: {
      show: true,
      bottom: "5%",
      itemGap: 16,
      icon: "rect",
    },

    series: [
      {
        name: "",
        type: "pie",
        radius: ["40%", "70%"], // 设置内外半径，实现环形效果，第一个值是内半径，第二个是外半径
        center: ["50%", "48%"], // 饼图中心位置，相对于容器的百分比
        avoidLabelOverlap: false,
        label: {
          show: true,
          position: "center",
          fontSize: 16,
          fontWeight: "bold",
          formatter: function () {
            let total = option.series[0].data.reduce((sum, item) => sum + item.value, 0);
            return `{total|${total}}\n\n{unit|${className == ".site-overview-echarts" ? "站点总数" : "设备总数"}}`;
          },
          rich: {
            unit: {
              fontSize: 14,
              color: "#333",
              fontWeight: 600,
            },
            total: {
              fontSize: 20,
              color: "#333",
              fontWeight: 600,
            },
          },
        },
        data: data.data,
      },
    ],
  };
  myChart.clear();
  option && myChart.setOption(option);
  myChart.resize({
    animation: {
      duration: 2800,
      easing: "cubicInOut",
      // delay: 500,
    },
  });
  window.onresize = () => {
    myChart.resize();
  };
};

let animateUp = ref(false);
const scrollAnimate = function () {
  animateUp.value = true;
  setTimeout(() => {
    if (alarmMessageDataList.value && alarmMessageDataList.value.length > 0) {
      alarmMessageDataList.value.push(alarmMessageDataList.value[0]);
      alarmMessageDataList.value.shift();
      animateUp.value = false;
    }
  }, 500);
};
const lunbo = function () {
  setInterval(scrollAnimate, 4000);
};

watch(
  () => props.dataDetail,
  (newValue) => {
    if (!newValue) return;
    siteData.value.data.forEach((item) => {
      item.value = newValue[item.key];
    });
    equipmentData.value.data.forEach((item) => {
      item.value = newValue[item.key];
    });
    alarmMessageDataList.value = newValue.warnLogList || [];
    pieChartLoad(".site-overview-echarts", siteData.value);
    pieChartLoad(".device-overview-echarts", equipmentData.value);
  }
);
onMounted(() => {
  lunbo();
});
</script>

<style lang="scss" scoped>
.right-content {
  width: 388px;
  box-sizing: border-box;
}

.site-overview,
.device-overview {
  .content-wrap {
    display: flex;
    padding-right: 36px;
    .echarts-container {
      flex: 1;
    }
    .info-container {
      width: 120px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      .info-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
        padding: 15px 0;
        .label {
          font-weight: bold;
          font-size: 14px;
          line-height: 14px;
          color: #333333;
          margin-bottom: 14px;
        }
        .value {
          font-weight: bold;
          font-size: 28px;
          line-height: 28px;
          color: #333333;
        }
      }
    }
  }
  .site-overview-echarts,
  .device-overview-echarts {
    width: 100%;
    height: 254px;
  }
}
.device-overview,
.alarm-message {
  margin-top: 20px;
}
.alarm-message {
  .content-wrap {
    padding: 16px;
  }
  .strategyBox {
    height: 100%;
    overflow: hidden;
    .titleBox {
      height: 25px;

      .trBox {
        height: 25px !important;

        .thBox {
          line-height: 25px;
        }
      }
    }
    .titleBox,
    .contentBox {
      overflow: hidden;

      .trBox {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .thBox,
        .tdBox {
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: 500;
          font-size: 14px;
          color: #1d2129;
        }
        .thBox:nth-child(1),
        .tdBox:nth-child(1) {
          width: 18%;
          text-align: left;
        }

        .thBox:nth-child(2),
        .thBox:nth-child(3),
        .tdBox:nth-child(2),
        .tdBox:nth-child(3) {
          width: 18%;
        }

        .thBox:nth-child(4),
        .tdBox:nth-child(4) {
          flex: 1;
          padding-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }
        .tdBox {
          font-size: 12px;
          color: #1d2129;
          line-height: 12px;
        }
      }

      .animate-up {
        transition: all 0.5s ease-in-out;
        transform: translateY(-40px);
      }
    }
    .contentBox {
      .trBox {
        border-bottom: 1px solid #e5e6eb;
      }
    }
  }
  .custom-empty{
    padding: 0;
  }
}
.section {
  .title-wrap {
    height: 45px;
    margin-bottom: 10px;
  }
  .content-wrap {
    box-sizing: border-box;
    height: 254px;
    background: linear-gradient(90deg, #e5f0ff 0%, rgba(255, 255, 255, 0.7) 100%);
    box-shadow: 4px 4px 6px 0px rgba(24, 54, 89, 0.12);
    border-radius: 0px 0px 30px 30px;
    border: 1px solid;
    border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
  }
}
</style>
